export enum BarMeldingType {
    Opgelost = 'OPGELOST',
    Informatief = 'INFORMATIEF',
    Belangrijk = 'BELANGRIJK',
    
    Onbeschikbaar = 'ONBESCHIKBAAR',
    /** @deprecated */     
    Banner = 'BANNER'
}
